import { render, staticRenderFns } from "./ATask.vue?vue&type=template&id=498d7aa3&scoped=true"
import script from "./ATask.vue?vue&type=script&lang=js"
export * from "./ATask.vue?vue&type=script&lang=js"
import style0 from "./ATask.vue?vue&type=style&index=0&id=498d7aa3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498d7aa3",
  null
  
)

export default component.exports